export default "__VITE_ASSET__WA9ERYGo__"